import filter from "./filter_zh";
import order_commen from "./order_commen_zh";
import single_list from "./single_list_zh";
import single_create from "./single_create_zh";
import game_detail from "./game_detail_zh";
import refund from "./refund_zh";
import consumption from "./consumption_zh";
import recharge_list from "./recharge_list_zh";
import private_create from "./private_create_zh";
import product_list from "./product_list_zh";
import product_create from "./product_create_zh";
import product_detail from "./product_detail_zh";
const orderModel = {
    filter,
    order_commen,
    single_list,
    single_create,
    game_detail,
    refund,
    consumption,
    recharge_list,
    private_create,
    product_list,
    product_create,
    product_detail
};

export default orderModel;
